import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { useMyContext } from 'Context/MyContextProvider';
import Maintenance from 'views/app-views/whatsapp/Maintenance/Maintenance';
import PushNotificationButton from 'views/app-views/whatsapp/Home/PushNotificationButton';


const ProtectedRoute = () => {
	const { maintenance, userRole, isMainServer } = useMyContext();
	const { token, user } = useSelector(state => state.auth);
	const location = useLocation();

	const allowedRoutes = ['/chatbot-map', '/manage-request', '/default-response', '/chatbot-flows'];
	const isAllowedRoute = (path) => {
		const dynamicRoutePattern =
			/^\/manage-request\/(add|edit)\/\d+$|^\/users\/manage\/\d+\/setting$|^\/chatbot-flows(\/|$)/;
		return allowedRoutes.includes(path) || dynamicRoutePattern.test(path);
	};

	if (!token) {
		if (isMainServer) {
			return <Navigate to={`home`} replace />;
		} else {
			return <Navigate to={`login`} replace />;
		}
	}

	// Wait until user details are loaded to prevent premature redirection
	if (token && !user) {
		return null;
	}

	const getRequiredPermissionForRoute = (path) => {
		if (path === '/template' || path.startsWith('/template/')) return 'View Template';
		if (path === '/carousel/template' || path.startsWith('/carousel/template/')) return 'View Template';
		if (path === '/out-reports' || path === '/global-reports') return 'View Outgoing Reports';
		if (path === '/incoming-reports') return 'View Incoming Reports';
		if (path === '/re-target-campaign' || path === '/carousel/campaign' || path === '/carousel/re-target-campaign') return 'View Campaign';
		if (path === '/campaign-history' || path === '/schedule-campaign') return 'View Campaign History';
		if (path === '/groups' || path.startsWith('/groups/')) return 'View Group';
		if (path.startsWith('/users/manage/')) {
			if (path.endsWith('/edit-profile')) return 'View Edit Profile';
			if (path.endsWith('/billing')) return 'View Billing';
			if (path.endsWith('/change-password')) return 'Change Password';
			if (path.endsWith('/permissions')) return 'View User Permission';
			if (path.endsWith('/credential')) return 'View Meta Credential';
			if (path.endsWith('/security')) return 'View User Security';
			if (path.endsWith('/setting')) return 'View System Setting';
		}
		if (path === '/users' || path.startsWith('/users/')) return 'View User';
		if (path === '/credit-history') return 'View Payment History';
		if (path === '/live-status') return 'View Live Status';
		return null;
	};

	const requiredPermission = getRequiredPermissionForRoute(location.pathname);
	const Permisson = user?.permissions;

	if (requiredPermission && Permisson && !Permisson.includes(requiredPermission) && !Permisson.includes('View User')) {
		return <Navigate to="/404" replace />;
	}

	return (
		<>
			<PushNotificationButton />
			{maintenance && !isAllowedRoute(location.pathname) && userRole !== 'Admin' ? (
				<Maintenance />
			) : (
				<Outlet />
			)}
		</>
	);
}

export default ProtectedRoute